// Libs
import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Button } from "antd";
import { SaveOutlined } from "@ant-design/icons";

// Components
import Input from "@cores/components/Input";

// Helper
import { createSubmitAction } from "@/helpers";
import { changeUserPasswordSubmitRules } from "../../helper";

// Action 
import { changePasswordUserAccount } from "../../actions";
import { USER_ACCOUNT_CHANGE_PASSWORD_REQUEST } from "../../constants";

class ChangeUserPasswordForm extends React.Component {

  onSubmit = (values, dispatch) => {
    const { onCancel } = this.props;
    return createSubmitAction(
      changeUserPasswordSubmitRules(values),
      changePasswordUserAccount
    )(values, dispatch).then((response) => {
      if (response?.error == null) {
        onCancel();
      }
    });
  }

  render() {
    const { handleSubmit, changUserPasswordLoading } = this.props;
    return (
      <Form onFinish={handleSubmit(this.onSubmit)} layout="vertical">
        <Row>
          <Col lg="12" md="12" sm="12" xs="12">
            <Input
              required
              autoFocus
              label="Current password"
              name="oldPassword"
              type="Password"
              autoComplete="new-password"
            />
          </Col>
          <Col lg="12" md="12" sm="12" xs="12">
            <Input
              required
              label="New Password"
              name="newPassword"
              type="Password"
              autoComplete="new-password"
              tip="At least 6 characters with uppercase, lowercase, and a number (e.g. Abc123). Special characters are optional."
            />
          </Col>
          <Col lg="12" md="12" sm="12" xs="12">
            <Input
              required
              label="Confirm Password"
              name="confirmPassword"
              type="Password"
              autoComplete="new-password"
            />
          </Col>
          <Col md="12" sm="12" xs="12">
            <Button 
              ghost
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
              className="float-right"
              loading={changUserPasswordLoading}
            >
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

ChangeUserPasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  changUserPasswordLoading: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { userId } = ownProps;
  return { 
    changUserPasswordLoading: state.request[USER_ACCOUNT_CHANGE_PASSWORD_REQUEST],
    initialValues: {
      userId
    }
  };
};

const changUserPassword = reduxForm()(ChangeUserPasswordForm);

export default withRouter(connect(mapStateToProps)(changUserPassword));